var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-badge',_vm._b({staticClass:"text-center ellipsis",style:({ background: _vm.color }),attrs:{"color":_vm.color,"label":_vm.$attrs.label ||_vm.$attrs.name}},'q-badge',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }